import type { LiveConnectionState } from "./liveConnection";
import type { LiveThreadSnapshot } from "./threadLiveClient";

/** What a Run's log shows before its first entries: still loading, no live connection, or the log itself. */
export type LogStart = "loading" | "noConnection" | "started";

/**
 * Whether a Run's log has started: entries came, or the server answered its subscription. Before that it loads
 * while the live socket opens for the first time or is open; once a try failed, no live connection reaches the
 * server. A refused origin is one: the server answers its upgrade with HTTP 403, which the browser reports as a
 * drop, so the client tries again and the log would otherwise load for good (usability round 4, P1).
 */
export function logStartOf(snapshot: LiveThreadSnapshot | undefined, connection: LiveConnectionState): LogStart {
  if (snapshot !== undefined && (snapshot.log.entries.length > 0 || snapshot.delivery !== "subscribing")) return "started";
  return connectionFailed(connection) ? "noConnection" : "loading";
}

function connectionFailed(connection: LiveConnectionState): boolean {
  switch (connection.status) {
    case "idle":
    case "open":
      return false;
    case "connecting":
      return connection.failures > 0;
    case "waitingToRetry":
    case "sessionEnded":
    case "refused":
      return true;
  }
}
